export var searchLocale = {
  clear: 'Clear'
};